/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */

import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ApiService } from "@app/@core/services/api";

@Injectable()
export class AdminComplianceService {
  constructor(private apiService: ApiService, private router: Router) { }

  getBatch(year = null, quarter = null) {
    let url = "admin/bsc";
    url += year && quarter ? "/" + year + "/" + quarter : "";
    return this.apiService.get(url);
  }

  toggleBatchRelease(year, quarter, release) {
    return this.apiService.post("admin/bsc/batch/" + year + "/" + quarter + "/release", { release });
  }

  approveBatch(year, quarter) {
    return this.apiService.post("admin/bsc/batch/" + year + "/" + quarter + "/approve");
  }

  completeBatch(year, quarter) {
    return this.apiService.post("admin/bsc/batch/" + year + "/" + quarter + "/complete");
  }

  getAssociates(year, quarter) {
    let url = "admin/bsc/associates/" + year + "/" + quarter;
    return this.apiService.get(url);
  }

  computeAssociates(year, quarter) {
    let url = "admin/bsc/associates/" + year + "/" + quarter + "/compute";
    return this.apiService.post(url);
  }

  initAssociates(year, quarter, associates) {
    let url = "admin/bsc/associates/" + year + "/" + quarter;
    return this.apiService.post(url, { associates });
  }

  getSubmissions(associate_uuid) {
    let url = "admin/bsc/associates/" + associate_uuid + "/submissions";
    return this.apiService.get(url);
  }

  tagSubmission(bsc_sample_id, submission_uuid) {
    return this.apiService.post("admin/bsc/samples/" + bsc_sample_id + "/submission/" + submission_uuid);
  }

  completeAssociate(year, quarter, bsc_associate_id) {
    return this.apiService.post("admin/bsc/associates/" + bsc_associate_id + "/complete");
  }

  prepareSamples(year, quarter, bsc_associate_id, round) {
    return this.apiService.post("admin/bsc/associates/prepare_samples/" + year + "/" + quarter + "/" + bsc_associate_id + "/" + round);
  }

  newSample(year, quarter, bsc_associate_id, round) {
    return this.apiService.post("admin/bsc/associates/new_sample/" + year + "/" + quarter + "/" + bsc_associate_id + "/" + round);
  }

  removeSample(bsc_sample_id) {
    return this.apiService.delete("admin/bsc/samples/" + bsc_sample_id);
  }

  getSupervisors(year, quarter) {
    let url = "admin/bsc/supervisors/" + year + "/" + quarter;
    return this.apiService.get(url);
  }

  computeSupervisors(year, quarter) {
    let url = "admin/bsc/supervisors/" + year + "/" + quarter + "/compute";
    return this.apiService.post(url);
  }

  completeSupervisor(year, quarter, bsc_associate_id) {
    return this.apiService.post("admin/bsc/supervisors/" + year + "/" + quarter + "/" + bsc_associate_id + "/complete");
  }

  getSamples(year, quarter, bsc_associate_id) {
    let url = "admin/bsc/samples/" + year + "/" + quarter + "/" + bsc_associate_id;
    return this.apiService.get(url);
  }

  updateSample(bsc_sample_id, data) {
    let url = "admin/bsc/samples/" + bsc_sample_id;
    return this.apiService.post(url, data);
  }

  generateBatchSamples(year, quarter) {
    return this.apiService.post("admin/bsc/batch/" + year + "/" + quarter + "/samples");
  }

  generateBatchAssociates(year, quarter) {
    return this.apiService.post("admin/bsc/batch/" + year + "/" + quarter + "/associates");
  }

  generateBatchSupervisors(year, quarter) {
    return this.apiService.post("admin/bsc/batch/" + year + "/" + quarter + "/supervisors");
  }

  generateAssociateSamples(bsc_associate_id) {
    return this.apiService.post("admin/bsc/associates/" + bsc_associate_id + "/samples");
  }

  generateAssociateLetter(bsc_associate_id) {
    return this.apiService.post("admin/bsc/associates/" + bsc_associate_id + "/letter");
  }

  downloadGeneratedExport(key) {
    return this.apiService.download("admin/bsc/download/" + key);
  }

  downloadPFR(submission_uuid, file_id) {
    return this.apiService.download("admin/bsc/download_pfr/" + submission_uuid + "/media/" + file_id);
  }

  downloadAuditTool(sample_uuid) {
    return this.apiService.download("admin/bsc/samples/" + sample_uuid + "/audit-tool");
  }


  //


  getBlacklist() {
    let url = "admin/bsc/blacklist";
    return this.apiService.get(url);
  }

  storeBlacklist(formData) {
    let url = "admin/bsc/blacklist";
    return this.apiService.post(url, formData);
  }

  updateBlacklist(id, formData) {
    let url = `admin/bsc/blacklist/${id}`;
    return this.apiService.patch(url, formData);
  }

  deleteBlacklist(id) {
    let url = `admin/bsc/blacklist/${id}`;
    return this.apiService.delete(url);
  }

  //

  reloadAllSamples(year, quarter) {
    return this.apiService.post("admin/bsc/batch/" + year + "/" + quarter + "/reload");
  }

  reloadAsscSamples(bsc_assc_id) {
    return this.apiService.post("admin/bsc/associates/" + bsc_assc_id + "/reload");
  }

  //

  uniquePolicies(year, quarter) {
    return this.apiService.get("admin/bsc/batch/" + year + "/" + quarter + "/unique-policies");
  }



  // downloadReport(key){
  //   return this.apiService.download("admin/bsc/download_report/" + key);
  // }

  // getFeeds(year, quarter) {
  //   let url = "admin/bsc/feeds/" + year + "/" + quarter;
  //   return this.apiService.get(url);
  // }

  // getRecords(feed_id) {
  //   let url = "admin/bsc/feeds/records";
  //   return this.apiService.post(url, {feed_id});
  // }

  // processFeed(form_data) {
  //   let url = "admin/bsc/feeds/process";
  //   return this.apiService.post(url, form_data);
  // }

  // uploadFeed(year, month, form_data) {
  //   let url = "admin/bsc/feeds/" + year + "/" + month;
  //   return this.apiService.upload(url, form_data);
  // }

  // deleteFeed(feed_id){
  //   return this.apiService.delete("admin/bsc/feeds/" + feed_id);
  // }

  // downloadFeed(feed_id){
  //   return this.apiService.download("admin/bsc/feeds/download/" + feed_id);
  // }

  // generateBatchSummary(year, month){
  //   return this.apiService.post("admin/bsc/generate_batch_summary/" + year + "/" + month);
  // }

  // generateFeedRecords(feed_id){
  //   return this.apiService.post("admin/bsc/feeds/generate_export_records/" + feed_id);
  // }

  // generateFeedComputations(feed_id){
  //   return this.apiService.post("admin/bsc/feeds/generate_export_computations/" + feed_id);
  // }


  // generateCsvExport(year, month){
  //   return this.apiService.post("admin/bsc/generate_csv_export/" + year + "/" + month);
  // }

  // generateProvidersBreakdown(year, month){
  //   return this.apiService.post("admin/bsc/generate_providers_breakdown/" + year + "/" + month);
  // }

  // getRepsForPayslipsPreview(year, month){
  //   return this.apiService.get("admin/bsc/reps_for_payslips_preview/" + year + "/" + month);
  // }
}
